import React, { useState, memo, useEffect } from "react";
import { Div, Text } from "../../../../StyledComponents";
import {
  Image,
  Span,
} from "../../../setting/PatientPortalSettings/StyledComponents";
import { useHistory } from "react-router-dom";
import docuIcon from "../../../../assets/images/document_notify_icon.png";
import demoIcon from "../../../../assets/images/demo_notify_icon.png";
import reportIcon from "../../../../assets/images/report_notify_icon.png";
import formIcon from "../../../../assets/images/consent_form_notify_icon.png";
import generalNotificationIcon from "../../../../assets/images/general_notify_icon.svg";
import {
  globalColor,
  globalFont,
} from "../../../utils/RepeatFunctions/Schedule";
import { ModalDialog, DataDiv } from "./../styles";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../../MiddleWare/EncryptDecrypt";
import axiosInstance from "../../../../axios/axios";

const Notification = ({
  dropChange,
  count,
  setGeneralNotificationModal,
  setTreatmentPlans,
}) => {
  const navigate = useHistory();
  const loggedUserID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  const togggleNotification = async () => {
    setGeneralNotificationModal(true);

    let payload = {
      providerID: loggedUserID,
      remainer: "1",
      isReviewed: "0",
    };
    let encrypted = Encrypt_Value(payload, "vozo");
    axiosInstance
      .post("/vozo/patient/gettreatmentplan", encrypted)
      .then((response) => {
        let plansData = Decrypt_Value(response.data, "vozo");
        setTreatmentPlans(plansData);
      })
      .catch((error) => {
        console.error("Error:", error);
        setTreatmentPlans([]);
      });
  };

  const NotificationList = [
    {
      icon: docuIcon,
      title: "Documents Uploaded",
      count: "doc_count",
      descp: "Review the documents uploaded by patients in patient portal",
    },
    {
      icon: demoIcon,
      title: "Patient Demographics",
      count: "demo_count",
      descp:
        "Patients requested to change their demographics in patient portal",
    },
    {
      icon: formIcon,
      title: "Consent Form - Signed by Patients",
      count: "consent_count",
      descp: "Consent form which was sent for review, reviewed & signed",
    },
    {
      icon: reportIcon,
      title: "Lab Reports",
      count: "report_count",
      descp: "Results for the patients lab orders  has been reported",
    },
    {
      icon: generalNotificationIcon,
      title: "General Notification",
      count: "treatment_plan_notify",
      descp: "Updates related to score and graph measures",
    },
  ];

  const redirect = (name) => {
    let url = name.replace("_count", "");
    if (name === "report_count") {
      navigate.push("/patient/electronicreports");
    } else {
      navigate.push("/settings/patientportal/" + url);
      window.location.reload();
    }
    dropChange();
  };

  return (
    <>
      {NotificationList.map((x, i) => (
        <Div
          key={i}
          display="flex"
          alignItem="center"
          padding="12px 16px"
          backcolor="rgba(64, 123, 255, 0.1)"
          borderBottom="1px solid rgba(46, 46, 46, 0.25)"
          margin={i === NotificationList.length - 1 && "0 0 40px"}
          onClick={() => {
            x.title === "General Notification"
              ? togggleNotification()
              : redirect(x.count);
          }}
          cursor="pointer"
        >
          <Image height="40px" width="40px" src={x.icon} alt="icon"></Image>
          <Div paddingLeft="12px" backColor="none">
            <Text
              color="#2E2E2E"
              featureSettings=" 'clig' off, 'liga' off"
              fontFamily={globalFont}
              fontSize="14px"
              display="flex"
              alignItem="center"
              fontStyle="normal"
              fontWeight="600"
              padding="0 0 4px"
              margin="0"
            >
              {x.title}
              {Object.entries(count).length > 0 && count[x.count] !== null && (
                <Span
                  textAlign="center"
                  fontFamily={globalFont}
                  fontWeight="500"
                  fontSize="12px"
                  color="#ffffff"
                  lineHeight="15px"
                  margin="0 0 0 6px"
                  width="16px"
                  height="16px"
                  borderRadius="50%"
                  background={globalColor}
                  size="10px"
                  flexCenterAll
                >
                  {count[x.count]}
                </Span>
              )}
            </Text>
            <Text
              color="rgba(46, 46, 46, 0.50)"
              fontFamily={globalFont}
              fontSize="12px"
            >
              {x.descp}
            </Text>
          </Div>
        </Div>
      ))}
    </>
  );
};

export default memo(Notification);
